import { render, staticRenderFns } from "./arrow-down-outline.vue?vue&type=template&id=2f5a94fd&scoped=true&"
import script from "./arrow-down-outline.vue?vue&type=script&lang=js&"
export * from "./arrow-down-outline.vue?vue&type=script&lang=js&"
import style0 from "./arrow-down-outline.vue?vue&type=style&index=0&id=2f5a94fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5a94fd",
  null
  
)

export default component.exports